import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { name: 'Pool Builders', path: '/services' },
    { name: 'Kitchen Remodeling', path: '/services' },
    { name: 'Bathroom Remodeling', path: '/services' },
    { name: 'Roofing', path: '/services' },
    { name: 'HVAC', path: '/services' },
    { name: 'Backyard Renovations', path: '/services' },
  ];

  const companyLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'Contact', path: '/contact' },
  ];

  const legalLinks = [
    { name: 'Terms of Service', path: '/terms' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'WCAG Accessibility Statement', path: '/website-accessibility' },
  ];

  return (
    <footer className="bg-[#0f172a] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_fresh-renovo/artifacts/56q6ipws_logo-footer.webp" 
                alt="RenoNovo Logo" 
                className="h-8 w-auto object-contain"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Empowering home service contractors with qualified, high-conversion appointments. 
              Your growth partner in the home services industry.
            </p>
            <div className="space-y-3">
              <a 
                href="tel:+13212102777" 
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-200"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4" />
                <span>(321) 210-2777</span>
              </a>
              <a 
                href="mailto:lead@renonovo.com" 
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-200"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                <span>lead@renonovo.com</span>
              </a>
              <div className="flex items-start gap-3 text-white/70">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>1790 Hwy A1A, Suite 209<br/>Satellite Beach, FL 32937</span>
              </div>
            </div>
          </div>

          {/* Industries Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Industries</h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-white/70 hover:text-white transition-colors duration-200 text-sm flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-white/70 hover:text-white transition-colors duration-200 text-sm flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Ready to Grow?</h4>
            <p className="text-white/70 text-sm mb-6">
              Book a free strategy call and discover how RenoNovo can help grow your business.
            </p>
            <Link 
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-semibold px-6 py-3 rounded-sm text-sm shadow-[0_4px_14px_0_rgba(37,99,235,0.39)] hover:shadow-[0_6px_20px_0_rgba(37,99,235,0.5)] transition-all duration-200 hover:-translate-y-0.5"
              data-testid="footer-cta-btn"
            >
              Get Started
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} RenoNovo. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {legalLinks.map((link) => (
                <Link 
                  key={link.name}
                  to={link.path}
                  className="text-white/50 hover:text-white transition-colors duration-200 text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
